import Button from '@propertypal/web-ui/src/buttons/Button';
import React from 'react';
import { useTheme } from 'styled-components';
import { Container, HeaderBox, HeaderTextBox, GradientBgAngle, Tabs } from './SuperFeature.style';

interface SuperFeatureProps {
  hero: string;
  subHeadingMaxW?: number;
}

const SuperFeature: React.FC<SuperFeatureProps> = ({ hero, subHeadingMaxW }) => {
  const theme = useTheme();
  return (
    <HeaderBox hero={hero} data-testid="superfeature">
      <Container>
        <HeaderTextBox subHeadingMaxW={subHeadingMaxW}>
          <h1>You need a new website!</h1>

          <h2 data-testid="superfeature-text">
            And we know just what to do to get the most out of your online enterprise.
          </h2>

          <Button
            type="button"
            onClick={() => document.getElementById('getInTouch')?.scrollIntoView({ behavior: 'smooth' })}
            testID="scroll-to-button"
          >
            Let&apos;s chat
          </Button>
        </HeaderTextBox>
      </Container>

      <GradientBgAngle color={theme.primary} />

      <Tabs />
    </HeaderBox>
  );
};

export default SuperFeature;
